/**
 * @generated SignedSource<<7e928d73da49412592cc95d5fb20ac54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userTracking_regionalInfo$data = {
  readonly incomeLevel: {
    readonly incomeBracket: string | null;
    readonly incomePercentile: string | null;
  } | null;
  readonly " $fragmentType": "userTracking_regionalInfo";
};
export type userTracking_regionalInfo$key = {
  readonly " $data"?: userTracking_regionalInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"userTracking_regionalInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_regionalInfo",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "zipCode"
        }
      ],
      "concreteType": "IncomeLevel",
      "kind": "LinkedField",
      "name": "incomeLevel",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incomeBracket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incomePercentile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RegionalInfo",
  "abstractKey": null
};

(node as any).hash = "f02bdb39ee092a2d4baa8aff15f762e3";

export default node;
